const $inject = ['$q'];

const lbDialogService = function ($q) {
  let service = {};

  service.visible = false;
  service.selectedItem = null;
  service.returnVal = null;

  service.options = {
    warningLevel: 'info',
    submitButtonText: 'Submit',
    showCancelButton: true,
  };

  service.show = show;
  service.cancel = cancel;
  service.submit = submit;

  function show(options) {
    service.selectedItem = null;
    service.returnVal = null;
    service.options = {
      warningLevel: 'info',
      submitButtonText: 'Submit',
      showCancelButton: true,
      selections: [],
    };

    _.assign(service.options, options);

    service.visible = true;

    service.returnVal = $q.defer();

    service.selectedItem = service.options.selections[0];

    return service.returnVal.promise;
  }

  function submit() {
    service.visible = false;

    service.returnVal.resolve({
      message: 'success',
      reason: service.selectedItem,
    });
  }

  function cancel() {
    service.visible = false;

    service.returnVal.reject({
      message: 'cancel',
    });
  }

  return service;
};

lbDialogService.$inject = $inject;

export default lbDialogService;



// WEBPACK FOOTER //
// ./src/components/lbDialog/lbDialogService.js